const MAX_WORDS = 6;
const MAX_CHARS = 50;

export function promptToFallbackTitle(prompt: string): string {
    const words = prompt.trim().split(/\s+/);
    const normalised = words.join(" ");
    let result = words.slice(0, MAX_WORDS).join(" ");
    if (result.length > MAX_CHARS) result = result.slice(0, MAX_CHARS);
    if (result.length < normalised.length) result += "…";
    return result;
}
